import { Box } from '@mui/material';
import { ErrorBox } from '#app/shared/components/Errors/ErrorBox';

export const AppFatalPage: React.FC = () => {
  return (
    <Box data-testid="application-fatal">
      <ErrorBox />
    </Box>
  );
};
